import { createSlice } from '@reduxjs/toolkit';
import { createProUser } from './createProUser.thunks';
import { RootState } from '../rootReducer';

export interface ICreateProUserState {
  saving: boolean;
}

export const initialState: ICreateProUserState = {
  saving: false
};

export const selectCreateProUserIsSaving = (state: RootState): boolean => state.users.createProAccount.saving;

const createProUserSlices = createSlice({
  name: 'createProUser',
  initialState,
  reducers: {},
  extraReducers: {
    [createProUser?.pending.type]: (state: ICreateProUserState) => {
      state.saving = true;
    },
    [createProUser?.fulfilled.type]: (state: ICreateProUserState) => {
      state.saving = initialState.saving;
    },
    [createProUser?.rejected.type]: (state: ICreateProUserState) => {
      state.saving = initialState.saving;
    }
  }
});

export default createProUserSlices.reducer;
